import { useCallback } from 'react';

import { useConfirmation } from './useConfirmation';

import type { User } from '@/types/directory/User';

/**
 * Asks before a launched anonymous 360 invites the respondents added to it: once invited, they can no longer be
 * removed. `confirm` resolves at once when no one was added, otherwise when the person answers the dialog.
 */
export const useConfirmLockedAdditions = () => {
    const { pending = [], ask, answer } = useConfirmation<User[]>();

    const confirm = useCallback(
        (added: User[]) => (added.length ? ask(added) : Promise.resolve(true)),
        [ask],
    );

    return { pending, confirm, answer };
};
